export const strings = {
  en: {
    nav: { home: "Home", plans: "Plans", founders: "Founders", gallery: "Gallery", contact: "Contact" },
    whatsapp: "WhatsApp",
    subscribe_now: "Subscribe Now",
    hero: {
      hindi: "गीर गाय का ताज़ा दूध व घी",
      title: "Pure GIR Gaumata Milk",
      subtitle: "100% Pure Desi GIR Cow Milk  ·  No Chemicals  ·  No Preservatives  ·  Free Home Delivery in Navi Mumbai",
      cta_subscribe: "Book ₹84 Trial",
      cta_whatsapp: "WhatsApp Us",
      stats: { families: "2,300+ Happy Families", gir: "100% GIR Gaumata", zero: "Zero Chemicals", six: "Delivered by 6 AM" },
      live_counter: "47 new families subscribed this week",
      tagline: "Har Boond Mein Amrit",
    },
    rate: {
      label: "Current Milk Rate",
      note: "All plans calculated at transparent market rate — no hidden charges",
      milk: "GIR Cow Milk",
      ghee: "Bilona Ghee",
    },
    why: {
      eyebrow: "Why Choose Us",
      title: "Why Divya Dhara?",
      subtitle: "आपकी सेहत का रखवाला — Your trusted source for pure GIR Gaumata milk since 2022",
    },
    health: {
      eyebrow: "Health Benefits",
      title: "Why GIR Cow Milk?",
      subtitle: "प्राचीन काल से रोग प्रतिरोधक शक्ति का उत्कृष्ट स्रोत",
    },
    founders: {
      eyebrow: "Meet the Team",
      title: "Our Founders",
      subtitle: "Driven by purity. Built on trust. Inspired by Gaumata.",
      watch: "Watch Video",
      story_title: "Why We Started Divya Dhara",
      story: "\"We started Divya Dhara because our own families deserved milk that was truly pure. After seeing adulteration in the market, we made a commitment — to bring real GIR Gaumata milk to every family in Navi Mumbai.\"",
      story_p2: "No shortcuts. No chemicals. Just honesty in every drop. Matrubhumi Gauras Bhandar is our promise to Navi Mumbai — pure, fresh, authentic GIR cow milk delivered to your door every morning.",
      stats: { fam: "Families", yrs: "Years", rating: "Rating", ret: "Retention" },
    },
    plans: {
      eyebrow: "Choose Your Plan",
      title: "Subscription Plans",
      subtitle: "Try 1 day at ₹84 or go straight to monthly subscription!",
      tab_milk: "GIR Cow Milk",
      tab_ghee: "Pure Cow Ghee",
      popular: "MOST POPULAR",
    },
    rate: {
      label: "Today's Rate",
      milk: "A2 GIR Cow Milk",
      milk_sub: "Subscription starts ₹100/L",
      ghee: "Pure Cow Ghee",
      ghee_price: "Price on request — Call us",
      note: "All prices include free home delivery. Sealed food-grade packaging.",
    },
    delivery: {
      eyebrow: "Check Availability",
      title: "Do We Deliver To Your Area?",
      subtitle: "Enter your pincode to check delivery availability",
      check: "Check Availability",
      areas: "We deliver across Navi Mumbai: Airoli · Rabale · Ghansoli · Koparkhairane · Vashi · Sanpada · Turbhe · Juinagar · Nerul · Seawoods · CBD Belapur · Kharghar · Kamothe · Kalamboli · Taloja · Panvel · Ulwe · Dronagiri · Uran",
    },
    how: {
      eyebrow: "Simple Process",
      title: "How It Works",
      subtitle: "Getting pure GIR Gaumata milk is as easy as 1-2-3!",
      steps: [
        { title: "Subscribe Online", text: "Choose plan on website or WhatsApp +91 98199 33676." },
        { title: "Doorstep Delivery 🚚", text: "Fresh A2 GIR Milk from 6 AM onwards — every single day." },
        { title: "Enjoy Pure Amrit ✨", text: "Start every morning with pure GIR Gaumata milk." },
      ],
    },
    promise: {
      eyebrow: "Our Promise",
      title: "Shuddhta Ka Vaada",
      badges: ["Zero Hormones", "No Water Added", "GIR Certified", "FSSAI Approved", "Natural Feed Only", "Fresh Daily", "Direct From Farm", "Zero Adulteration"],
      counters: [
        { n: "2300+", l: "Happy Families" },
        { n: "100%",  l: "Pure GIR Milk" },
        { n: "0",     l: "Chemicals — Ever" },
        { n: "730+",  l: "Days Serving" },
      ],
    },
    diff: {
      eyebrow: "Our Farm",
      title: "See the Difference",
      subtitle: "Watch our founders and farm in action — pure, natural, honest.",
    },
    testimonials: {
      eyebrow: "Happy Customers",
      title: "What Our Families Say",
      subtitle: "2,300+ families in Navi Mumbai trust Divya Dhara every morning",
    },
    offer: {
      eyebrow: "⚡ SPECIAL TRIAL PRICE",
      title: "Try Before You Subscribe! 🥛",
      subtitle: "1 Day Trial at ₹84 — no lock-in, cancel anytime.",
      remaining: "Only 22 trial slots remaining this week!",
      cta: "🥛 Book ₹84 Trial Now →",
      fine: "Pay ₹84 first day. ₹100/L if you subscribe. No pressure.",
    },
    faq: {
      eyebrow: "Got Questions?",
      title: "Frequently Asked Questions",
    },
    footer: {
      tagline: "Pure A2 Gir cow milk delivered fresh to Navi Mumbai households every morning.",
      quick_links: "Quick Links",
      delivery_areas: "Delivery Areas",
      reach_us: "Reach Us",
      home: "Home",
      founders: "Founders",
      gallery: "Gallery",
      delivery: "Delivery Areas",
      track: "Track Delivery",
      rights: "All rights reserved.",
      fssai: "FSSAI compliant",
      areas: {
        nerul: "Nerul", seawoods: "Seawoods", belapur: "CBD Belapur", sanpada: "Sanpada",
        vashi: "Vashi", turbhe: "Turbhe", juinagar: "Juinagar", airoli: "Airoli",
        rabale: "Rabale", ghansoli: "Ghansoli", kopar: "Koparkhairane", kharghar: "Kharghar",
        kamothe: "Kamothe", kalamboli: "Kalamboli", taloja: "Taloja", panvel: "Panvel",
        ulwe: "Ulwe", dronagiri: "Dronagiri", uran: "Uran",
      },
    },
    chat: {
      open: "Chat with us",
      title: "Divya Dhara Support",
      subtitle: "We usually reply instantly",
      placeholder: "Type your message…",
      send: "Send",
      greeting: "Namaste 🙏 Welcome to Divya Dhara — Pure A2 Desi Cow Milk 🐄\n\nHow can I help you today?",
      options: ["🥛 ₹84 Trial (1 Day)", "Start Subscription", "Know More", "Contact / Visit"],
    },
    contact: {
      eyebrow: "Get In Touch",
      title: "Contact Us",
      form_heading: "Send Us a Message",
      name: "Full Name",
      phone: "Mobile Number",
      plan: "Plan Interested In",
      message: "Message",
      send: "Send via WhatsApp",
      address_title: "Our Address",
      address: "Matrubhumi Gauras Bhandar, 25, Nav Durga CHS, Plot No: 7/7, Sec-19A, Nerul, Navi Mumbai 400 706",
      call_title: "Call Us",
      whatsapp_title: "WhatsApp",
      whatsapp_text: "Chat with us on WhatsApp — fastest response!",
      email_title: "Email",
    },
  },
  hi: {
    nav: { home: "होम", plans: "योजनाएं", founders: "संस्थापक", gallery: "गैलरी", contact: "संपर्क" },
    whatsapp: "व्हाट्सऐप",
    subscribe_now: "अभी सब्सक्राइब करें",
    hero: {
      hindi: "गीर गाय का ताज़ा दूध व घी",
      title: "शुद्ध गीर गौमाता का दूध",
      subtitle: "100% शुद्ध देसी गीर गाय का दूध  ·  कोई रसायन नहीं  ·  कोई परिरक्षक नहीं  ·  नवी मुंबई में मुफ्त होम डिलीवरी",
      cta_subscribe: "₹84 परीक्षण बुक करें",
      cta_whatsapp: "व्हाट्सऐप करें",
      stats: { families: "2,300+ खुश परिवार", gir: "100% गीर गौमाता", zero: "शून्य रसायन", six: "सुबह 6 बजे तक डिलीवरी" },
      live_counter: "इस सप्ताह 47 नए परिवार जुड़े",
      tagline: "हर बूंद में अमृत",
    },
    rate: {
      label: "वर्तमान दूध दर",
      note: "सभी योजनाएँ पारदर्शी बाज़ार दर पर — कोई छिपा शुल्क नहीं",
      milk: "गीर गाय का दूध",
      ghee: "बिलोना घी",
    },
    why: {
      eyebrow: "क्यों चुनें हमें",
      title: "क्यों दिव्य धारा?",
      subtitle: "आपकी सेहत का रखवाला — 2022 से शुद्ध गीर गौमाता दूध का विश्वसनीय स्रोत",
    },
    health: {
      eyebrow: "स्वास्थ्य लाभ",
      title: "क्यों गीर गाय का दूध?",
      subtitle: "प्राचीन काल से रोग प्रतिरोधक शक्ति का उत्कृष्ट स्रोत",
    },
    founders: {
      eyebrow: "टीम से मिलें",
      title: "हमारे संस्थापक",
      subtitle: "शुद्धता से प्रेरित। विश्वास पर आधारित। गौमाता से प्रेरित।",
      watch: "वीडियो देखें",
      story_title: "हमने दिव्य धारा क्यों शुरू की",
      story: "\"हमने दिव्य धारा इसलिए शुरू की क्योंकि हमारे अपने परिवार सच्चे शुद्ध दूध के हकदार थे। बाज़ार में मिलावट देखकर, हमने नवी मुंबई के हर परिवार तक असली गीर गौमाता का दूध पहुँचाने का वादा किया।\"",
      story_p2: "कोई शॉर्टकट नहीं। कोई रसायन नहीं। हर बूंद में ईमानदारी। मातृभूमि गौरस भंडार नवी मुंबई से हमारा वादा है।",
      stats: { fam: "परिवार", yrs: "वर्ष", rating: "रेटिंग", ret: "रिटेंशन" },
    },
    plans: {
      eyebrow: "अपनी योजना चुनें",
      title: "सब्सक्रिप्शन योजनाएं",
      subtitle: "₹84 में 1 दिन आज़माएं या सीधे मासिक सदस्यता लें!",
      tab_milk: "GIR गौमाता दूध",
      tab_ghee: "शुद्ध गौमाता घी",
      popular: "सबसे लोकप्रिय",
    },
    delivery: {
      eyebrow: "उपलब्धता जाँचें",
      title: "क्या हम आपके क्षेत्र में डिलीवर करते हैं?",
      subtitle: "डिलीवरी की जाँच के लिए पिनकोड डालें",
      check: "जाँचें",
      areas: "सम्पूर्ण नवी मुंबई में डिलीवरी: ऐरोली · रबाले · घनसोली · कोपरखैराणे · वाशी · सानपाडा · तुर्भे · जुईनगर · नेरुल · सीवूड्स · सीबीडी बेलापुर · खारघर · कामोठे · कालंबोली · तलोजा · पनवेल · उलवे · द्रोणागिरि · उरण",
    },
    how: {
      eyebrow: "सरल प्रक्रिया",
      title: "कैसे काम करता है",
      subtitle: "शुद्ध GIR गौमाता दूध पाना 1-2-3 जितना सरल है!",
      steps: [
        { title: "ऑनलाइन सदस्यता लें", text: "+91 98199 33676 पर WhatsApp करें।" },
        { title: "द्वार पर डिलीवरी 🚚", text: "प्रातः 6 बजे से ताज़ा दूध आपके द्वार पर।" },
        { title: "शुद्ध अमृत का आनंद लें ✨", text: "प्रतिदिन शुद्ध GIR गौमाता दूध से दिन प्रारंभ करें।" },
      ],
    },
    promise: {
      eyebrow: "हमारा वादा",
      title: "शुद्धता का वादा",
      badges: ["शून्य हार्मोन", "जल मिश्रण नहीं", "GIR प्रमाणित", "FSSAI अनुमोदित", "प्राकृतिक आहार", "प्रतिदिन ताज़ा", "सीधे फ़ार्म से", "शून्य मिलावट"],
      counters: [
        { n: "2300+", l: "संतुष्ट परिवार" },
        { n: "100%",  l: "शुद्ध GIR दूध" },
        { n: "0",     l: "रसायन — कभी नहीं" },
        { n: "730+",  l: "दिनों की सेवा" },
      ],
    },
    diff: {
      eyebrow: "हमारा फार्म",
      title: "फर्क देखिए",
      subtitle: "हमारे संस्थापकों और फार्म को काम करते देखें — शुद्ध, प्राकृतिक, ईमानदार।",
    },
    testimonials: {
      eyebrow: "ख़ुश ग्राहक",
      title: "हमारे परिवारों का कहना",
      subtitle: "नवी मुंबई के 2,300+ परिवार हर सुबह दिव्य धारा पर भरोसा करते हैं",
    },
    offer: {
      eyebrow: "सीमित समय की पेशकश",
      title: "पहला लीटर बिल्कुल FREE! 🎁",
      subtitle: "1 दिन FREE ट्रायल — कोई भुगतान नहीं, कोई प्रतिबद्धता नहीं।",
      remaining: "इस सप्ताह सिर्फ़ 22 ट्रायल स्लॉट बचे हैं!",
      cta: "ट्रायल बुक करें",
      fine: "कोई लॉक-इन नहीं। कभी भी रद्द करें — केवल डिलीवर हुए दूध का भुगतान।",
    },
    faq: {
      eyebrow: "सवाल हैं?",
      title: "अक्सर पूछे जाने वाले सवाल",
    },
    footer: {
      tagline: "नवी मुंबई के घरों तक हर सुबह ताज़ा शुद्ध A2 गीर गौमाता का दूध।",
      quick_links: "त्वरित लिंक",
      delivery_areas: "डिलीवरी क्षेत्र",
      reach_us: "संपर्क करें",
      home: "होम",
      founders: "संस्थापक",
      gallery: "गैलरी",
      delivery: "डिलीवरी क्षेत्र",
      track: "डिलीवरी ट्रैक करें",
      rights: "सर्वाधिकार सुरक्षित।",
      fssai: "FSSAI अनुमोदित",
      areas: {
        nerul: "नेरुल", seawoods: "सीवूड्स", belapur: "सीबीडी बेलापुर", sanpada: "सानपाडा",
        vashi: "वाशी", turbhe: "तुर्भे", juinagar: "जुईनगर", airoli: "ऐरोली",
        rabale: "रबाले", ghansoli: "घनसोली", kopar: "कोपरखैराणे", kharghar: "खारघर",
        kamothe: "कामोठे", kalamboli: "कालंबोली", taloja: "तलोजा", panvel: "पनवेल",
        ulwe: "उलवे", dronagiri: "द्रोणागिरि", uran: "उरण",
      },
    },
    chat: {
      open: "हमसे चैट करें",
      title: "दिव्य धारा सहायता",
      subtitle: "हम तुरंत जवाब देते हैं",
      placeholder: "अपना संदेश लिखें…",
      send: "भेजें",
      greeting: "नमस्ते 🙏 दिव्य धारा में आपका स्वागत है — शुद्ध A2 देसी गाय का दूध 🐄\n\nमैं आपकी कैसे मदद कर सकता हूँ?",
      options: ["🎁 FREE ट्रायल (1 दिन)", "सब्सक्रिप्शन शुरू करें", "और जानें", "संपर्क / मिलें"],
    },
    contact: {
      eyebrow: "संपर्क करें",
      title: "हमसे बात करें",
      form_heading: "हमें संदेश भेजें",
      name: "पूरा नाम",
      phone: "मोबाइल नंबर",
      plan: "योजना",
      message: "संदेश",
      send: "व्हाट्सऐप पर भेजें",
      address_title: "हमारा पता",
      address: "मातृभूमि गौरस भंडार, 25, नव दुर्गा CHS, प्लॉट नं 7/7, सेक्टर-19A, नेरुल, नवी मुंबई 400 706",
      call_title: "कॉल करें",
      whatsapp_title: "व्हाट्सऐप",
      whatsapp_text: "व्हाट्सऐप पर चैट करें — सबसे तेज़ जवाब!",
      email_title: "ईमेल",
    },
  },
};
